import { AnimatePresence, motion } from "framer-motion"
import { useEffect, useRef } from "react";

interface Props {
    toggle:boolean
    editFunc: () => void,
    deleteFunc: () => void,
    setToggle: ()=> void
}

const CardOpt = ({ toggle, setToggle, editFunc, deleteFunc }: Props) => {

    const optBox = useRef<HTMLDivElement>(null)

       useEffect(() => {
            const handleClickOutside = (event: MouseEvent) => {
                if (
                    toggle &&
                    optBox.current &&
                    !optBox.current.contains(event.target as Node)) {
    
                   setToggle()
                }
    
            }
    

            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                document.removeEventListener("mousedown", handleClickOutside);
            };
    // eslint-disable-next-line
        }, [toggle]);


    return (
        <>
            <AnimatePresence>
                {toggle && (
                    <motion.div ref={optBox} className='optBox' initial={{ opacity: 0, scale: 0.8, y: -10 }}
                        animate={{ opacity: 1, scale: 1, y: 0 }}
                        exit={{ opacity: 0, scale: 0.8, y: -10 }}
                        transition={{ duration: 0.2 }}>
                        <div className='eachpopt' onClick={editFunc}>Edit Card</div>
                        <div className='eachpopt' onClick={deleteFunc}>Delete Card</div>
                    </motion.div>
                )}
            </AnimatePresence>
        </>
    )


}

export default CardOpt